import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { hasPermission, PERMISSION_IDS } from '../../utils/permissions';
import './Error401Page.css';
import { log } from '../../utils/logger';

const Error401Page = () => {
  const navigate = useNavigate();
  const { token, user } = useAuth();

  useEffect(() => {
    // Si el usuario está autenticado, verificar permisos
    if (token && user) {
      // Si tiene permiso PanelAdmin, redirigir al dashboard
      const hasAccess = hasPermission(user, PERMISSION_IDS.PANEL_ADMIN);
      if (hasAccess) {
        log('Error401Manager: Usuario autenticado con permisos, redirigiendo al dashboard');
        navigate('/admin/dashboard', { replace: true });
        return;
      } else {
        // Si está autenticado pero no tiene permisos, redirigir a 403
        log('Error401Manager: Usuario autenticado sin permisos, redirigiendo a 403');
        navigate('/403', { replace: true });
        return;
      }
    }

    // Configurar redirección automática después de 30 segundos
    const timeoutId = setTimeout(() => {
      log('Error401Manager: Redirección automática a inicio');
      navigate('/', { replace: true });
    }, 30000);

    return () => clearTimeout(timeoutId);
  }, [token, user, navigate]);

  const handleLogin = () => {
    navigate('/login', { replace: true });
  };

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="error-page error-401">
      <div className="error-content">
        <div className="error-icon">
          <i className="fas fa-shield-alt" />
        </div>

        <h1 className="error-code">401</h1>
        <h2 className="error-title">Acceso No Autorizado</h2>
        <p className="error-description">
          Debes iniciar sesión para acceder a esta área.
        </p>

        <div className="error-actions">
          <button type="button" className="btn btn-primary" onClick={handleLogin}>
            <i className="fas fa-sign-in-alt" />
            Iniciar Sesión
          </button>
          <button type="button" className="btn btn-secondary" onClick={handleGoHome}>
            <i className="fas fa-home" />
            Volver al Inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error401Page;





